import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Tab, Tabs, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import UseVoucherForm from '../../components/forms/useVoucherForm';
import VoucherHistory from '../../components/voucher/history';
import VoucherStatus from '../../components/voucher/status';
import { VoucherStore } from '../../stores/VoucherStore';

const voucherStore = new VoucherStore();
const Voucher = observer(() => {
  const [resetFormKey, setResetFormKey] = useState(1);
    useEffect(() => {voucherStore.load();}, []);
    const { t } = useTranslation('voucher');
  return (
    <div className="voucher">
      <div className="wrap voucher-wrap">
        <div className="container">
          <h1>Gestione voucher</h1>
        </div>
      </div>
      <div className="container">
        <main className="main ">
            <Tabs
              defaultActiveKey="manageVoucher"
              className="mb-3 voucher-tabs"
            >
              <Tab eventKey="manageVoucher" title="Riepilogo">
                <div className="mb-4 text-center">
                  <h3 className="text-center mb-3 gradient-title">{t("voucherSummary")}</h3>
                  <p>{t("voucherSummaryText")}</p>
                </div>
                  <VoucherStatus voucherStore={voucherStore} />
              </Tab>
              <Tab eventKey="voucherHistory" title="Storico">
                <div className="mb-4 text-center">
                  <h3 className="text-center mb-3 gradient-title">{t("voucherHistory")}</h3>
                  <p>{t("voucherHistoryText")}</p>
                </div>
                <VoucherHistory voucherStore={voucherStore} />
              </Tab>
              <Tab eventKey="useVoucher" title="Utilizza">
                <div className="mb-4 text-center">
                  <h3 className="text-center mb-3 gradient-title">{t("useVoucher")}</h3>
                  <p>{t("voucherUseText")}</p>
                </div>
                <UseVoucherForm key={resetFormKey} store={voucherStore} />
                <div className='row'>
                    <div className='col-md-12 px-3'>
                        <Button  variant="secondary" className="w-100" onClick={() => setResetFormKey(resetFormKey+1)}>
                            Reset
                        </Button>
                    </div>
                </div>
              </Tab>
            </Tabs>
        </main>
      </div>
    </div>
  )
})

export default Voucher
